import React from "react";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core";
import Card from "@material-ui/core/Card";
// import Divider from "@material-ui/core/Divider";

// import InfoIcon from "@material-ui/icons/Info";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import Table from "jazasoft/lib/mui/components/Table";

import CardHeader from "../../../components/CardHeader";

import useDeepMemo from "../../../hooks/useDeepMemo";
import { getColumnsFabricUsageSummary, getRowsFabricUsageSummary } from "../cutPlanHelper";
import { OState } from "../../../utils/types";
import useSafeState from "../../../hooks/useSafeState";

import Drawer from "./flow-details/Drawer";
import hasPrivilege from "../../../utils/hasPrivilege";
import ResourceId from "../../../utils/ResourceId";
import { Scope } from "../../../utils/privilege";
import { useSetting } from "../../../hooks";
import SettingKeys from "../../../utils/SettingKeys";
import { isTrue } from "../../../utils/helpers";

const useStyles = makeStyles({
  table: {
    "& th, & td": {
      border: "1px solid rgba(224, 224, 224, 1)",
      minWidth: 80
    }
  }
});

const FabricUsageSummary = props => {
  const { className, order, cutOrder, uom, rollInfoList, ledgerList, fabricPatternList, planTabIdx, roles, hasAccess } = props;
  const classes = useStyles();

  const history = useHistory();
  const [drawerState, setDrawerState] = useSafeState({ opne: false, flowInfoList: [], orderFlowList: [] });

  const showStdCuVal = useSetting(SettingKeys.SHOW_STD_CU);
  const showStdCu = isTrue(showStdCuVal);

  const onLinkClick = hasPrivilege(roles, hasAccess, ResourceId.FABRIC, Scope.READ)
    ? row => {
        history.push(`/warehouse/fabrics/${row?.fabricId}/view`);
      }
    : null;

  const rows = useDeepMemo(
    () => getRowsFabricUsageSummary(order, cutOrder, rollInfoList, ledgerList, fabricPatternList, uom, planTabIdx),
    [order, cutOrder, rollInfoList, ledgerList, fabricPatternList, planTabIdx]
  );

  const columns = useDeepMemo(() => {
    let colList = getColumnsFabricUsageSummary(cutOrder, planTabIdx, uom, onLinkClick);
    if (rows?.length <= 1) {
      colList = colList.filter(c => c.dataKey !== "cutAll");
    }
    if (!showStdCu) {
      colList = colList.filter(c => c.dataKey !== "stdCu");
    }
    return colList;
  }, [cutOrder, planTabIdx, rows, showStdCu, uom]);

  // const onInlineActionClick = (event, action, row) => {
  //   setDrawerState({ open: true, flowInfoList: row.flowInfoList, orderFlowList: row.orderFlowList });
  // };

  if (cutOrder?.stateValue <= OState.MAIN_CUTPLAN_GENERATED.stateValue || cutOrder?.stateValue === OState.CUTPLAN_IN_PROGRESS.stateValue) {
    return <div />;
  }

  return (
    <div>
      <Drawer
        open={drawerState?.open || false}
        order={order}
        flowInfoList={drawerState.flowInfoList}
        orderFlowList={drawerState.orderFlowList}
        onDrawerClose={() => setDrawerState({ open: false, flowInfoList: [], orderFlowList: [] })}
      />

      <Card className={className}>
        <CardHeader title="Fabric Usage Summary" />
        {/* <Divider /> */}
        <PerfectScrollbar>
          <Table
            classes={{ table: classes.table }}
            columns={columns}
            rows={rows}
            // fontSize={16}
            // cellLength={15}
            // inlineActions={[{ name: "info", tooltip: "Info", icon: <InfoIcon /> }]}
            // onInlineActionClick={onInlineActionClick}
            i18nKey="resources.cutPlan.fields.flowInfo"
          />
        </PerfectScrollbar>
      </Card>
    </div>
  );
};

export default FabricUsageSummary;
